import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// components
import { Row } from "react-bootstrap";
import { BsFillPlusCircleFill } from "react-icons/bs";

import SearchBar from "../../../components/SearchBar";
import ProtectedAccess  from '../../../components/ProtectedAccess'
//page
import BookItem from "./BookItem";

import TextLoader from '../../../components/TextLoader/TextLoader';
import CustomPagination from '../../../components/CustomPagination';
import { getRandomBooks, searchBooksByText } from '../../../api/books';

import Dialog from "../create/CreateBookDialog";
import BookDetails from "../detailed";

import { saveStorageBooks, getStorageBooks } from '../../../utils/common';


const BookGallery = (props) => {

  const { lang, query, setQuery} =  props;

  const BOOKS_PER_PAGE = 15; // TODO: add to admin settings 
  
  const [loading, setLoading] = useState(true);
  const [books, setBooks] = useState([]);
  const [step, setStep] = useState(1);
  const [pages, setPages] = useState(1);
  const [show, setShow] = useState(false);
  const [current, setCurrent] = useState(null);

  // const [query, setQuery]= useState(props.query || "");
  const [viewer, setViewer]= useState(false);
  const params = useParams()
  const history = useNavigate()
  const { id } = params;

  // const { searchText } = useParams();

  const handleClose = () => {
    setCurrent(null)
    setShow(false)
  };

  const handleShow = (user) =>{
    setCurrent(user)
    setShow(true)
  };

  const fetchBooks = async () => {
    setViewer(false);
    if (query){
      setLoading(true);
      history("/editorial/books")
      const {data:{docs, pages}} = await searchBooksByText(query)
        .catch(function (error) {
          setLoading(false);
          return {data:[]};
        })
      setBooks(docs);
      setPages(pages);
      setLoading(false);
      return null;

    }else{
      // Busque en el storage
      let data = getStorageBooks(step)
      // Busque en la API
      if(!data){
        const {data:{docs, pages}} = await getRandomBooks(BOOKS_PER_PAGE, step)
        .catch(function (error) {
          setLoading(false);
          return {data:[]};
        })
        // Aleatorice
        let books = docs.sort((a, b) => Math.random() < 0.6 ? 1 : -1)
        // Guarde en el storage
        saveStorageBooks({books, offset:step, pages})
        // Show authors
        setBooks(books);
        setLoading(false);
        setPages(pages);
        return null;
      }
      const {books, pages}=data;
      // Show authors
      setBooks(books);
      setLoading(false);
      setPages(pages);
      return null;
    }
  }

  useEffect(() => {
    if(id){
      setViewer(true);
    }else{
      fetchBooks();
    }
  }, [id, query])

  useEffect(() => {
    if(query !== ""){fetchBooks();}
  }, [query])
  

  const nextFetchBooks = async (step) => {
    if (query){

    }else{
      // Busque en el storage
      let data = getStorageBooks(step)
      // Busque en la API
      if(!data){
        const {data:{docs, pages}} = await getRandomBooks(BOOKS_PER_PAGE, step)
        .catch(function (error) {
          setLoading(false);
          return {data:[]};
        })
        // Aleatorice
        let books = docs.sort((a, b) => Math.random() < 0.6 ? 1 : -1)
        // Guarde en el storage
        saveStorageBooks({books, offset:step, pages})
        // Show authors
        setBooks(books);
        setLoading(false);
        setPages(pages);
        return null;
      }
      const {books, pages}=data;
      // Show authors
      setBooks(books);
      setLoading(false);
      setPages(pages);
      return null;
    }
  }

  const updateStorage = (resp) =>{
    console.log("resp ", resp);
    const {data: book} = resp;
    // updateStorage
    let {books, pages} = getStorageBooks(step)
    let updated = books.map(item=>{
      if(book._id == item._id) return book;
      return item;
    })
    if(!book.active) updated = updated.filter((item) => book._id !== item._id)

    saveStorageBooks({books:updated, offset:step, pages})
    // reloadStorageAuthors
    setBooks(updated);
  }

  const paginateBooks = () => {
    let booksToDisplay = [];
    books.map(item=>{
      booksToDisplay.push(
        <BookItem 
          key={item._id}
          id={item.isbn13}
          book={item} 
          BOOKS_PER_PAGE={BOOKS_PER_PAGE} 
          handleShow={()=>handleShow(item)}
          lang={lang} 
          updateStorage={(resp)=> updateStorage(resp)}
          />
      )
    })

    return booksToDisplay
  }
  const displayBooks = () => {
    return (
      <>
        <ProtectedAccess 
          element={
            <div>
              <button 
                className="btn btn-primary"
                style={{ margin:'10px 0px', width:'100%' }}
                onClick={()=>handleShow(null)} >
                  <BsFillPlusCircleFill size={20}/> AGREGAR AL CATÁLOGO
              </button>
            </div>
          }
          role={['admin', 'editor']}
          lang={lang}
        />
        <div className="gallery" style={{ display:'flex', flexWrap:'wrap', justifyContent:'center' }}>
            <Dialog
              show={show} 
              handleClose={handleClose}
              lang={lang}
              current={current}
              onFinish={(resp)=> updateStorage(resp) }
            />            
            {paginateBooks()}
        </div >
        <Row>
          <CustomPagination 
            step={step} 
            setStep={setStep} 
            pages={pages}
            pagesToShow={13}
            fetchData={nextFetchBooks} />
        </Row>
      </>
    )
  }

  const showGalleryBooks = () => {

    if(viewer){
      return (
        <BookDetails {...{...props, id}}/>
      );
    }

    // If the books are not present yet, display loading feedbaack to user.
    if (loading) {
      return (
        <Row className=''>
          <div style={{ paddingTop: '40px' }} />
          <TextLoader
            upperMessage={lang.book.loading.books_upper}
            lowerMessage={lang.book.loading.books_lower}
          />
        </Row>
      )
    }

    // TODO retornar un componente especial cuando no existan libros para mostrar.
    if (books && books.length === 0) {
      return (
        <>
          <Row className='justify-content-md-center' style={{height:'70vh'}}>
            <div style={{ paddingTop: '10px' }} />
            <TextLoader
              upperMessage={'No se han obtenido libros.'} //lang.author.loading.books_upper}
              lowerMessage={''} //lang.author.loading.books_lower}
            />
          </Row>
          <Row className='justify-content-md-center'>
            <CustomPagination 
              step={step} 
              setStep={setStep} 
              pages={pages} 
              pagesToShow={13}
              fetchData={nextFetchBooks} />
          </Row>
        </>
      )
    }

    return displayBooks();
  }

  return (
    <>
      <SearchBar 
        searchItem={ setQuery }
        query={query}
        setQuery={setQuery}
        placeholder={lang.book.title}
      />
      <Row className=''>
        {showGalleryBooks()}
      </Row>
    </>
  );
};

export default BookGallery;
